// eslint-disable-next-line import/no-unresolved
import { Platform } from "react-native";

const isNative = Platform.OS === "android" || Platform.OS === "ios";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => isNative;
